export const CHUNKS_EN_2 = [
  "es",
  "in",
  "er",
  "ti",
  "on",
  "at",
  "te",
  "is",
  "re",
  "ng",
  "en",
  "st",
  "ed",
  "ri",
  "al",
  "li",
  "ra",
  "an",
  "le",
  "ne",
  "se",
  "ar",
  "ic",
  "or",
  "ro",
  "nt",
  "it",
  "ie",
  "co",
  "la",
  "ss",
  "io",
  "de",
  "ns",
  "ca",
  "rs",
  "ni",
  "as",
  "ta",
  "tr",
  "di",
  "to",
  "he",
  "me",
  "ch",
  "un",
  "lo",
  "ll",
  "ol",
  "el",
  "et",
  "ou",
  "ma",
  "mi",
  "si",
  "pe",
  "il",
  "ve",
  "na",
  "ac",
  "ly",
  "us",
  "om",
  "ea",
  "hi",
  "ia",
  "th",
  "ho",
  "ur",
  "os",
  "nd",
  "ts",
  "ph",
  "ce",
  "no",
  "ec",
  "ha",
  "sh",
  "ul",
  "ge",
  "op",
  "pr",
  "nc",
  "po",
  "ot",
  "pa",
  "ab",
  "mo",
  "em",
  "ci",
  "og",
  "am",
  "bl",
  "pi",
  "id",
  "ut",
  "ap",
  "sa",
  "iz",
  "ct",
];

export const CHUNKS_EN_3 = [
  "ing",
  "ess",
  "ati",
  "ion",
  "nes",
  "ers",
  "ies",
  "ter",
  "tio",
  "ses",
  "ate",
  "ent",
  "ist",
  "ons",
  "ine",
  "tin",
  "ali",
  "sse",
  "tic",
  "ise",
  "est",
  "lin",
  "per",
  "ica",
  "eri",
  "res",
  "all",
  "ous",
  "iti",
  "ver",
  "ant",
  "ble",
  "cal",
  "les",
  "ted",
  "con",
  "tra",
  "rin",
  "tes",
  "men",
  "lis",
  "ene",
  "tor",
  "tri",
  "rat",
  "ize",
  "lit",
  "sti",
  "nte",
  "abl",
  "dis",
  "ngs",
  "ste",
  "ism",
  "lat",
  "der",
  "oni",
  "nti",
  "ari",
  "gra",
  "ili",
  "ive",
  "pre",
  "ere",
  "str",
  "ove",
  "olo",
  "log",
  "pro",
  "her",
  "the",
  "int",
  "ris",
  "tie",
  "nis",
  "ran",
  "min",
  "era",
  "che",
  "red",
  "mat",
  "sin",
  "ast",
  "ect",
  "nde",
  "nce",
  "mis",
  "ato",
  "sta",
  "and",
  "ill",
  "ier",
  "ite",
  "lly",
  "rie",
  "tro",
  "ori",
  "ell",
  "cat",
  "sts",
];

export const CHUNKS_FR_2 = [
  "er",
  "on",
  "ra",
  "nt",
  "en",
  "ai",
  "es",
  "is",
  "re",
  "as",
  "ss",
  "ie",
  "se",
  "ns",
  "ri",
  "te",
  "dé",
  "an",
  "ez",
  "ro",
  "io",
  "ti",
  "in",
  "ou",
  "it",
  "si",
  "le",
  "la",
  "li",
  "co",
  "ta",
  "ar",
  "sa",
  "ch",
  "il",
  "tr",
  "ur",
  "me",
  "ll",
  "al",
  "ne",
  "at",
  "nn",
  "ré",
  "na",
  "qu",
  "or",
  "ma",
  "ca",
  "st",
  "és",
  "ue",
  "pa",
  "ni",
  "di",
  "em",
  "ât",
  "lo",
  "ée",
  "ir",
  "éc",
  "ge",
  "nc",
  "us",
  "so",
  "po",
  "ha",
  "ul",
  "to",
  "ac",
  "ui",
  "eu",
  "ér",
  "nd",
  "pr",
  "ol",
  "fi",
  "ag",
  "ot",
  "de",
  "mi",
  "om",
  "ve",
  "ap",
  "pe",
  "bo",
  "ét",
  "mo",
  "mp",
  "el",
  "ut",
  "ci",
  "ic",
  "té",
  "am",
  "pi",
  "au",
  "if",
  "et",
  "ba",
];

export const CHUNKS_FR_3 = [
  "ent",
  "ons",
  "era",
  "ass",
  "rai",
  "ion",
  "sse",
  "iez",
  "ron",
  "ssi",
  "ien",
  "ais",
  "onn",
  "ill",
  "ant",
  "aie",
  "ait",
  "ter",
  "eri",
  "ero",
  "ser",
  "ras",
  "tes",
  "ren",
  "ont",
  "iss",
  "rie",
  "ise",
  "lis",
  "ses",
  "ler",
  "sen",
  "ner",
  "sio",
  "con",
  "que",
  "lle",
  "mes",
  "sie",
  "isa",
  "rio",
  "nne",
  "ère",
  "ati",
  "nte",
  "cha",
  "ali",
  "tio",
  "rez",
  "ris",
  "tra",
  "men",
  "rer",
  "res",
  "iqu",
  "âte",
  "ier",
  "ere",
  "dés",
  "âme",
  "ées",
  "che",
  "déc",
  "las",
  "ssa",
  "our",
  "sai",
  "sas",
  "tas",
  "ine",
  "ran",
  "nna",
  "uer",
  "age",
  "ifi",
  "nas",
  "lla",
  "tai",
  "tre",
  "lai",
  "tri",
  "tis",
  "eur",
  "nis",
  "bou",
  "per",
  "par",
  "ail",
  "ntr",
  "ess",
  "int",
  "eme",
  "ina",
  "uil",
  "ver",
  "tte",
  "les",
  "nai",
  "sti",
  "ire",
];

export const CHUNKS_ES_2 = [
  "ar",
  "as",
  "ra",
  "es",
  "re",
  "en",
  "os",
  "is",
  "an",
  "ri",
  "mo",
  "ia",
  "de",
  "ca",
  "se",
  "er",
  "ta",
  "te",
  "ba",
  "ad",
  "la",
  "on",
  "am",
  "ab",
  "ea",
  "em",
  "st",
  "al",
  "co",
  "or",
  "na",
  "nt",
  "do",
  "in",
  "ro",
  "ai",
  "ei",
  "da",
  "ma",
  "ac",
  "ch",
  "ci",
  "ti",
  "le",
  "za",
  "ic",
  "tr",
  "sa",
  "nc",
  "ec",
  "pa",
  "nd",
  "li",
  "ga",
  "rr",
  "at",
  "ne",
  "il",
  "ce",
  "ol",
  "ll",
  "pe",
  "ie",
  "di",
  "ue",
  "sc",
  "to",
  "iz",
  "qu",
  "et",
  "ap",
  "ha",
  "el",
  "lo",
  "me",
  "io",
  "mi",
  "mp",
  "so",
  "ur",
  "it",
  "gu",
  "cu",
  "mb",
  "ul",
  "br",
  "pi",
  "ni",
  "ja",
  "si",
  "fi",
  "ir",
  "ng",
  "po",
  "pr",
  "om",
  "sp",
  "id",
  "ot",
  "im",
];

export const CHUNKS_ES_3 = [
  "mos",
  "ria",
  "des",
  "ara",
  "ari",
  "aba",
  "are",
  "ase",
  "amo",
  "eis",
  "ais",
  "emo",
  "ras",
  "ado",
  "ear",
  "ste",
  "ent",
  "ast",
  "res",
  "iza",
  "ran",
  "tar",
  "ada",
  "car",
  "era",
  "lar",
  "cha",
  "ias",
  "tra",
  "esc",
  "enc",
  "sen",
  "lla",
  "ren",
  "ica",
  "ese",
  "con",
  "rem",
  "ron",
  "est",
  "ona",
  "arr",
  "que",
  "nta",
  "nar",
  "ram",
  "ian",
  "and",
  "rar",
  "ina",
  "nte",
  "esa",
  "sem",
  "zar",
  "das",
  "rei",
  "eas",
  "tea",
  "sta",
  "ses",
  "rai",
  "ill",
  "ere",
  "one",
  "ndo",
  "bas",
  "rec",
  "ier",
  "ban",
  "tas",
  "iai",
  "sca",
  "esp",
  "dos",
  "iam",
  "tei",
  "ion",
  "aro",
  "sei",
  "ora",
  "gar",
  "rra",
  "las",
  "ali",
  "ant",
  "cas",
  "rea",
  "nas",
  "nca",
  "par",
  "ist",
  "emp",
  "dor",
  "bai",
  "eci",
  "mar",
  "bam",
  "eri",
  "ter",
  "per",
];
